import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/** Merge Tailwind classes so a caller's `className` can always override. */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
